import React, { useState, useEffect, useMemo } from 'react';
import Skills from './SKill';
import Contact from './Contacts';

const HomePage = () => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [typingSpeed, setTypingSpeed] = useState(150);

  const techSayings = useMemo(() => [
    "Code is poetry written in logic",
    "AI is the new electricity",
    "Machine Learning transforms data into wisdom",
    "Innovation distinguishes leaders from followers",
    "The future belongs to those who code it",
    "Deep Learning, Deeper Insights",
    "Algorithms are the recipes for digital magic",
    "Data is the oil of the 21st century",
    "Building tomorrow's solutions today",
    "Where creativity meets technology"
  ], []);


  // Typing effect
  useEffect(() => {
    const handleTyping = () => {
      const current = techSayings[currentIndex];
      
      if (isDeleting) {
        setCurrentText(current.substring(0, currentText.length - 1));
        setTypingSpeed(50);
      } else {
        setCurrentText(current.substring(0, currentText.length + 1));
        setTypingSpeed(150);
      }

      if (!isDeleting && currentText === current) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && currentText === '') {
        setIsDeleting(false);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % techSayings.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentIndex, typingSpeed, techSayings]);

  return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 text-white overflow-hidden relative">
        

        <div className="relative min-h-screen bg-gradient-to-br to-purple-400 to-slate-900 text-white overflow-hidden">
          {/* Decorative Background Elements */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-cyan-500/20 rounded-full opacity-70 filter blur-3xl -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-500/20 rounded-full opacity-70 filter blur-3xl translate-x-1/3 translate-y-1/3" />
          <div className="absolute top-1/2 left-1/4 w-32 h-32 bg-emerald-500/10 rounded-full opacity-50 filter blur-2xl" />

          {/* Hero Section */}
          <header className="relative flex flex-col items-center justify-center min-h-screen py-20 px-4">
            <div className="max-w-4xl mx-auto mt-16">
              {/* Profile Image */}
              <div className="mb-6 relative">
                <div className="w-28 h-28 md:w-32 md:h-32 mx-auto rounded-full overflow-hidden border-4 border-gradient-to-r from-cyan-400 to-purple-400 shadow-2xl shadow-cyan-500/20">
                  <img 
                    src="images/reagan.png"
                    alt="Reagan Scofield Mukandila"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div 
                    className="w-full h-full bg-gradient-to-br from-cyan-500 to-purple-500 flex items-center justify-center text-3xl font-bold hidden"
                  >
                    RS
                  </div>
                </div>
                {/* Animated ring around profile */}
                <div className="absolute inset-0 w-28 h-28 md:w-32 md:h-32 mx-auto rounded-full border-2 border-cyan-400/30 animate-ping"></div>
              </div>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-4xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent leading-tight">
                Reagan Scofield Mukandila
              </h1>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent leading-tight">
                Software | AI/ML Engineer
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl mb-3 md:mb-4 text-gray-300 font-light">
                Focused on the practical realization of innovative concepts via intelligent system design.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center">
                <a
                  href="/projects"
                  className="px-6 md:px-8 py-2.5 md:py-3 bg-gradient-to-r from-cyan-500 to-purple-500 text-white font-semibold rounded-full shadow-lg hover:from-cyan-400 hover:to-purple-400 hover:shadow-cyan-500/20 transition-all duration-300 transform hover:scale-105 w-full sm:w-auto text-center"
                >
                  View My Work
                </a>
                <a
                  href="/contact"
                  className="px-6 md:px-8 py-2.5 md:py-3 border-2 border-cyan-400 text-cyan-400 font-semibold rounded-full hover:bg-cyan-400 hover:text-slate-900 hover:shadow-lg hover:shadow-cyan-400/20 transition-all duration-300 w-full sm:w-auto text-center"
                >
                  Let's Connect
                </a>
              </div>
            </div>
            
            {/* Scroll Indicator */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
              <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
                <div className="w-1 h-3 bg-gray-400 rounded-full mt-2"></div>
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="relative">
            <section id="skills" className="py-16">
              <Skills />
            </section>
            <section id="contact" className="py-16">
              <Contact />
            </section>
          </main>
        </div>
      </div>
  );
};

export default HomePage;